module.exports = __webpack_public_path__ + "static/media/safety_pins.2eadb9a9.gif";